import { Navigate, useLocation } from "react-router-dom";
import { useAutenticacao } from "@/contextos/AutenticacaoContexto";

export function RotaProtegida({ children, perfilNecessario }) {
  const { usuario, carregando } = useAutenticacao();
  const location = useLocation();

  if (carregando) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-superficie-base">
        <div className="font-heading uppercase tracking-[0.3em] text-amarelobrasil text-sm">Carregando...</div>
      </div>
    );
  }

  if (!usuario) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (
    !usuario.regulamentoAceito &&
    usuario.perfil === "APOSTADOR" &&
    location.pathname !== "/aceitar-regulamento"
  ) {
    return <Navigate to="/aceitar-regulamento" replace />;
  }

  if (perfilNecessario) {
    const lista = Array.isArray(perfilNecessario) ? perfilNecessario : [perfilNecessario];
    if (!lista.includes(usuario.perfil)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}
